import {
  //
  ADD_NEWS,
  ADD_NEWS_FAILURE,
  ADD_NEWS_SUCCESS,
  //
  DELETE_NEWS,
  DELETE_NEWS_FAILURE,
  DELETE_NEWS_SUCCESS,
  //
  EDIT_NEWS,
  EDIT_NEWS_FAILURE,
  EDIT_NEWS_SUCCESS,
  //
  FETCH_NEWS,
  FETCH_NEWS_FAILURE,
  FETCH_NEWS_SUCCESS,
  //
  GET_VIEW_DATA,
  GET_VIEW_DATA_FAILURE,
  GET_VIEW_DATA_SUCCESS,
} from "./constants";

// List
export const fetchNews = (payload) => ({
  type: FETCH_NEWS,
  payload,
});
export const fetchNewsSuccess = (payload) => ({
  type: FETCH_NEWS_SUCCESS,
  payload,
});
export const fetchNewsFailure = (payload) => ({
  type: FETCH_NEWS_FAILURE,
  payload,
});
// View
export const getViewData = (payload) => ({
  type: GET_VIEW_DATA,
  payload,
});
export const getViewDataSuccess = (payload) => ({
  type: GET_VIEW_DATA_SUCCESS,
  payload,
});
export const getViewDataFailure = (payload) => ({
  type: GET_VIEW_DATA_FAILURE,
  payload,
});
// ADD
export const addNews = (payload) => ({
  type: ADD_NEWS,
  payload,
});
export const addNewsSuccess = (payload) => ({
  type: ADD_NEWS_SUCCESS,
  payload,
});
export const addNewsFailure = (payload) => ({
  type: ADD_NEWS_FAILURE,
  payload,
});
// EDIT
export const editNews = (payload) => ({
  type: EDIT_NEWS,
  payload,
});
export const editNewsSuccess = (payload) => ({
  type: EDIT_NEWS_SUCCESS,
  payload,
});
export const editNewsFailure = (payload) => ({
  type: EDIT_NEWS_FAILURE,
  payload,
});
// DELETE
export const deleteNews = (payload) => ({
  type: DELETE_NEWS,
  payload,
});
export const deleteNewsSuccess = (payload) => ({
  type: DELETE_NEWS_SUCCESS,
  payload,
});
export const deleteNewsFailure = (payload) => ({
  type: DELETE_NEWS_FAILURE,
  payload,
});
